import {downloadFile, _delete} from './Tools';

const downloadTxt = async (registro_patronal_id, fecha_inicial, fecha_final) => {
  try {
    const response = await downloadFile(`${process.env.REACT_APP_SERVER}idse_bajas/download?registro_patronal_id=${registro_patronal_id}&fecha_inicial=${fecha_inicial}&fecha_final=${fecha_final}`);
    return response;
  } catch (error) {
    console.error('Error en la descarga:', error);
    return { ok: false, message: error.message };
  }
};

export { downloadTxt };